import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannelBanResponseFilterSensitiveLog, } from "../models/models_0";
import { de_CreateChannelBanCommand, se_CreateChannelBanCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class CreateChannelBanCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "CreateChannelBan", {})
    .n("ChimeSDKMessagingClient", "CreateChannelBanCommand")
    .f(void 0, CreateChannelBanResponseFilterSensitiveLog)
    .ser(se_CreateChannelBanCommand)
    .de(de_CreateChannelBanCommand)
    .build() {
}
